import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { List, WingBlank } from 'antd-mobile'
import CardLayout from '../../components/common/CardLayout'
import { FormattedMessage, useIntl } from 'react-intl'
import UploadOssFile from '../../components/common/UploadOssFile'
import UploadFileWrapper from '../../components/common/UploadFileWrapper'
import { findEfrCert, findMasterFD, findOwsi } from '../../components/common/findCerts'
import { removeFDIFile, uploadFDIOssFile } from '../../reducers/fdi'

const Item = List.Item

const CheckCerts = ({ efrfiles, editable, fdiFiles, otherFiles, complete }) => {
  const { certifications, ossSignature, credentials } = useSelector((state) => ({
    certifications: state.data.certifications,
    credentials: state.data.credentials,
    ossSignature: state.oss.ossSignature,
  }))
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const filename = (type) => `${ossSignature.dir}${type}/${new Date().getTime()}`

  return (
    <CardLayout title={<FormattedMessage id="dm-form-required-certs" />} status={complete}>
      {/*
      证书要求：三选一 + EFR
      mfd
      owsi
      其他组织自由潜证书
    */}

      {findMasterFD(certifications) ? (
        <Item>
          <FormattedMessage id="fdi-master-cert" /> {`（${findMasterFD(certifications).studentNumber}）`}
        </Item>
      ) : findOwsi(credentials) ? (
        <Item>
          <FormattedMessage id="fdi-owsi-cert" /> <FormattedMessage id="afdi-satisfy" />
        </Item>
      ) : (
        <UploadFileWrapper labelName={formatMessage({ id: 'fdi-not-padi-cert' })} editable={editable}>
          <UploadOssFile
            fileList={fdiFiles || []}
            fileName={filename('fdi')}
            onChange={(formData) => {
              dispatch(uploadFDIOssFile({ formData }))
            }}
            onDelete={(index) => dispatch(removeFDIFile(fdiFiles[index]))}
            editable={editable}
          />
          {editable && (
            <WingBlank>
              <div className="small-font gray">
                <FormattedMessage id="common-upload-file-reminder" />
              </div>
            </WingBlank>
          )}
        </UploadFileWrapper>
      )}
      {/* efr */}
      {findEfrCert(certifications) ? (
        <Item>EFR {`（${formatMessage({ id: 'app-has-efr' })}）`}</Item>
      ) : (
        <UploadFileWrapper labelName={'EFR'} editable={editable}>
          <UploadOssFile
            fileList={efrfiles || []}
            fileName={filename('efr')}
            onChange={(formData) => {
              dispatch(uploadFDIOssFile({ formData }))
            }}
            onDelete={(index) => dispatch(removeFDIFile(efrfiles[index]))}
            editable={editable}
          />
          {editable && (
            <WingBlank>
              <div className="small-font gray">
                <FormattedMessage id="common-upload-file-reminder" />
              </div>
            </WingBlank>
          )}
        </UploadFileWrapper>
      )}
      <UploadFileWrapper labelName={formatMessage({ id: 'mermaid-other-files' })} editable={editable}>
        <UploadOssFile
          fileList={otherFiles || []}
          fileName={filename('other')}
          onChange={(formData) => {
            dispatch(uploadFDIOssFile({ formData }))
          }}
          onDelete={(index) => dispatch(removeFDIFile(otherFiles[index]))}
          editable={editable}
        />
        {editable && (
          <WingBlank>
            <div className="small-font gray">
              <FormattedMessage id="app-health" />
            </div>
          </WingBlank>
        )}
      </UploadFileWrapper>
    </CardLayout>
  )
}

export default CheckCerts
